import { atom } from 'jotai';

import { FacilityFormState } from '../types/facility';

const initialState: FacilityFormState = {
  facilityName: '',
  facilityType: '',
  timezone: '',
  address: {
    streetAddress: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
  },
  customAttributes: {},
};

export const $facilityForm = atom<FacilityFormState>(initialState);

export const $updateFacilityForm = atom(
  null,
  (get, set, update: Partial<FacilityFormState>) => {
    const currentState = get($facilityForm);
    set($facilityForm, {
      ...currentState,
      ...update,
      address: {
        ...currentState.address,
        ...(update.address ?? {}),
      },
    });
  },
);

export const $resetFacilityForm = atom(null, (get, set) => {
  set($facilityForm, initialState);
});
